import type { ReactNode } from 'react';

export function PageHeader({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children?: ReactNode;
}) {
  return (
    <header className="mb-6 flex items-start justify-between gap-4 border-b-2 border-ink pb-4">
      <div>
        <h1 className="text-2xl font-bold">{title}</h1>
        <p className="mt-1 max-w-3xl text-sm text-bruise">{description}</p>
      </div>
      {children}
    </header>
  );
}
